import { NavigateAction, ForwardAction, BackAction } from './types'
import { NAVIGATION_NAVIGATE, NAVIGATION_FORWARD, NAVIGATION_BACK } from './actionTypes'

export const navigate = (route: string): NavigateAction => ({
  type: NAVIGATION_NAVIGATE,
  route
})

export const back = (): ForwardAction => ({
  type: NAVIGATION_FORWARD
})

export const forward = (): BackAction => ({
  type: NAVIGATION_BACK
})
